import React from 'react';
import { useTranslation } from 'react-i18next';

// Section "Quiz Bonus" du règlement — transverse foot/rugby
export const QuizRulesSection = () => {
    const { t } = useTranslation();

    return (
        <section>
            <h3 className="font-bold text-gray-800 uppercase text-xs mb-2 tracking-wider flex items-center gap-1.5">
                <span>⚡</span> {t('quiz_rules.title', 'Le Quiz Bonus')}
            </h3>

            <p className="mb-3">
                {t('quiz_rules.intro', "En attendant le coup d'envoi, teste tes connaissances foot avec le quiz du jour : 5 questions chronométrées, environ 60 secondes.")}
            </p>

            <div className="bg-emerald-50 border border-emerald-100 rounded-lg p-3 mb-4 flex items-start gap-3">
                <span className="text-lg">🚀</span>
                <p className="text-[12px] text-emerald-800 leading-snug">
                    <strong>{t('quiz_rules.bonus_label', 'Un bonus pour ton classement.')}</strong>{' '}
                    {t('quiz_rules.bonus_content', "Les points du quiz s'ajoutent à ceux de ton prono. Plus tu réponds juste et vite, plus tu grimpes au classement.")}
                </p>
            </div>

            <div className="bg-slate-50 border border-slate-100 rounded-xl p-3 font-bold text-gray-800 text-center mb-4">
                {t('quiz_rules.formula', 'Points = points de base × (1 + temps restant / temps total)')}
            </div>

            <ul className="space-y-2">
                <li className="flex gap-2">
                    <span>⏱</span>
                    <span><strong>{t('quiz_rules.speed_label', 'La vitesse compte.')}</strong> {t('quiz_rules.speed_content', "Réponse instantanée = jusqu'à ×2 les points. À la dernière seconde = ×1,1. Hors délai = 0 point.")}</span>
                </li>
                <li className="flex gap-2">
                    <span>📅</span>
                    <span><strong>{t('quiz_rules.once_label', 'Un quiz par jour.')}</strong> {t('quiz_rules.once_content', 'Un seul quiz par jour, pas de seconde chance pour gonfler ton score.')}</span>
                </li>
            </ul>
        </section>
    );
};
